import React from "react";

import { Chart } from "../Chart";
import { Text } from "../Text";
import * as styles from "./styles";

export interface DonutChartProps {
  data: number[];
  labels: string[];
  colors?: string[];
  title?: string;
  icon?: JSX.Element;
}

export const DonutChart = ({ title, labels, data, icon }: DonutChartProps) => (
  <div className={styles.container}>
    <div className={styles.header}>
      <Text variant="p" noMargin weight="--ll-font-weight-bold">
        {title}
      </Text>
    </div>
    <Chart.Root data={data} labels={labels} icon={icon}>
      <div className={styles.chartContent}>
        <div className={styles.donutContainer}>
          <Chart.Donut />
        </div>
        <>
          <Chart.Legend />
        </>
      </div>
    </Chart.Root>
  </div>
);
